// extracted by mini-css-extract-plugin
module.exports = {"forgotPasswordText":"styles_forgotPasswordText__3IOwi"};